import { useTransition, animated } from '@react-spring/web'
import { createPortal } from 'react-dom'
import X from '@mui/icons-material/Clear'

const DEFAULT_TRANSITION_CONFIG = {
  from: { y: '50px', opacity: 0 },
  enter: { y: '0px', opacity: 1 },
  leave: { y: '50px', opacity: 0 },
  config: { tension: 250, friction: 25, mass: 1 },
}

export default function MinimalModal({ open, onClose, children, width = 840, footer = null }) {
  const transition = useTransition(open, DEFAULT_TRANSITION_CONFIG)

  const modalRoot = typeof document !== 'undefined' ? document.getElementById('modal-root') || document.body : null

  if (!modalRoot) return null

  return createPortal(
    transition(
      (style, item) =>
        item && (
          <animated.div
            style={{ opacity: style.opacity }}
            className='fixed inset-0 z-[1500] flex items-center justify-center bg-slate-950/40 backdrop-blur-[2px] p-4'
            onClick={onClose}
          >
            <animated.div
              style={{
                opacity: style.opacity,
                transform: style.y.to(y => `translateY(${y})`),
                width: '100%',
                maxWidth: width,
              }}
              className='relative flex flex-col bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh]'
              onClick={e => e.stopPropagation()}
            >
              {/* Header */}
              <div className='flex items-center justify-between bg-primary px-5'>
                <div /> {/* Espacio para balancear */}
                <button
                  onClick={onClose}
                  className='text-white/80 hover:text-white hover:bg-white/10 p-1.5 rounded-lg transition-all'
                >
                  <X style={{ fontSize: 20 }} />
                </button>
              </div>

              {/* Body */}
              <div className='flex-1 overflow-y-auto p-5 scroll-smooth custom-scrollbar'>
                {children}
              </div>

              {/* Footer */}
              {footer && (
                <div className='border-t border-slate-100 px-6 py-4 flex justify-end bg-slate-50/30'>
                  {footer}
                </div>
              )}
            </animated.div>

            <style>{`
              .custom-scrollbar::-webkit-scrollbar {
                width: 6px;
              }
              .custom-scrollbar::-webkit-scrollbar-track {
                background: transparent;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #e2e8f0;
                border-radius: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                background: #cbd5e1;
              }
            `}</style>
          </animated.div>
        )
    ),
    modalRoot
  )
}
